<template>
  <div>

    <loading-indicator
      v-if="isLoading"
    />

    <template v-if="contest !== null">
      <contest-concrete-stat
        :tmnt="contest"
      />

      <template v-if="isDownloadSectionVisible">
        <hr>
      
        <div class="mb-3">
          <b-button v-if="isDownloadRatingsJSONButtonVisible" @click="downloadRatingsJSON" class="mb-1">Download ratings JSON</b-button><br>
          <b-button v-if="isDownloadRatingsCSVButtonVisible"  @click="downloadRatingsCSV" class="mb-1">Download ratings CSV</b-button><br>
          <b-button v-if="isSaveRatingsForDashboardsButtonVisible" @click="saveRatingsForDashboards">Save ratings for dashboards</b-button>
        </div>
      </template>
    </template>

  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import {canDownloadRatingsJSON       } from '../model/contest.js';
import {canDownloadRatingsCSV        } from '../model/contest.js';
import {canSaveRatingsForDashboards  } from '../model/contest.js';
import {downloadRatingsJSON          } from '../controller/contest.js';
import {downloadRatingsCSV           } from '../controller/contest.js';

import LoadingIndicator from './LoadingIndicator.vue';
import ContestConcreteStat from './ContestConcreteStat.vue';

export default {
  name: 'ContestStat',

  components: {
    LoadingIndicator,
    ContestConcreteStat,
  },

  props: {
    contestId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      contest: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isDownloadSectionVisible() {
      if(this.isDownloadRatingsJSONButtonVisible) {
        return true;
      }

      if(this.isDownloadRatingsCSVButtonVisible) {
        return true;
      }

      if(this.isSaveRatingsForDashboardsButtonVisible) {
        return true;
      }

      return false;
    },

    /** @returns {boolean} */
    isDownloadRatingsJSONButtonVisible() {
      return canDownloadRatingsJSON(this.contest.type);
    },

    /** @returns {boolean} */
    isDownloadRatingsCSVButtonVisible() {
      return canDownloadRatingsCSV(this.contest.type);
    },

    /** @returns {boolean} */
    isSaveRatingsForDashboardsButtonVisible() {
      return canSaveRatingsForDashboards(this.contest.type);
    },
  },

  created() {
    notifier.deleteSenderNotifications(this);
    this.isLoading = true;

    const url = `/contest/${this.contestId}/stat`;
    HTTP.get(url)
    .then(response => {
      this.isLoading = false;

      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.', {sender: this});
        return;
      }

      this.contest = data;
    })
    .catch(err => {
      this.isLoading = false;
      notifier.showError(err, {sender: this});
    });
  },

  methods: {
    downloadRatingsJSON() {
      downloadRatingsJSON(this, this.contestId);
    },

    downloadRatingsCSV() {
      downloadRatingsCSV(this, this.contestId);
    },

    saveRatingsForDashboards() {
      notifier.deleteSenderNotifications(this);

      const url = `/contest/${this.contestId}/import_to_clickhouse`;
      HTTP.post(url)
      .then(() => {
        notifier.showSuccess('Ratings saved.');
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },
  },
};
</script>
